// roles.config.ts
export enum UserRole {
  ADMIN = 'admin',
  DEVELOPER = 'developer',
  CORPORATE = 'corporate',
  OWNER = 'owner',
  DEALER = 'dealer',
  SALES = 'sales',
  TECHNICIAN = 'technician',
  CUSTOMER = 'customer',
  NULL = 'null'
}

export const roleHierarchy: { [key in UserRole]: number } = {
  [UserRole.DEVELOPER]: 9,
  [UserRole.ADMIN]: 8,
  [UserRole.CORPORATE]: 7,
  [UserRole.OWNER]: 6,
  [UserRole.DEALER]: 5,
  [UserRole.SALES]: 4,
  [UserRole.TECHNICIAN]: 4, // Same level as SALES
  [UserRole.CUSTOMER]: 2,
  [UserRole.NULL]: 1
};

export const canSelectUser = (currentUserRole: UserRole | null, targetUserRole: UserRole | null, currentUserId: string, targetUserId: string): boolean => {
  // Prevent selecting self

  // Devs can select any user
  if (currentUserRole === UserRole.DEVELOPER) {
    return true;
  }

  if (currentUserId === targetUserId) {
    return false;
  }
  
  // Handle null roles
  const currentRole = currentUserRole || UserRole.NULL;
  const targetRole = targetUserRole || UserRole.NULL;
  
  // Compare role levels
  const currentUserLevel = roleHierarchy[currentRole];
  const targetUserLevel = roleHierarchy[targetRole];
  
  // User can only select users with lower or equal role level
  return currentUserLevel > targetUserLevel;
};